import { AddIcon } from "@assets/icons";
import { Input } from "@components/ui/input";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import TextEditor, { RichTextEditor } from "@ui/external/components/texteditor";
import { Equal, PlusCircle, PlusCircleIcon, X, XIcon } from "lucide-react";
import React from "react";
import { Control, Controller } from "react-hook-form";

type ItemType = {
  type: "description" | "quotation" | "image";
  id: number;
  question?: string;
  answer?: string;
  description?: string;
  label?: string;
  image?: File | string | "";
  children?: ItemType[];
};

interface DragChildProps {
  field: ItemType;
  control: Control<any>; // or your exact Form type
  id: number; // index in the items array
  addChildToDescription: (index: number) => void;
  isDragActive: boolean;
  currentItems: ItemType[];
  remove: (id: number) => void;
  getValues: any;
  setValue: any;
}

const DragChild: React.FC<DragChildProps> = ({
  field,
  control,
  currentItems,
  isDragActive = false,
  remove,
  id,
  addChildToDescription,
  getValues,
  setValue,
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({
      id: field?.id,
    });
  console.log("currentItems", currentItems);
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  if (!field.type) {
    if (
      field?.hasOwnProperty("description") &&
      field?.hasOwnProperty("title")
    ) {
      field.type = "description";
    } else {
      field.type = "quotation";
    }
  }
  switch (field?.type) {
    case "quotation":
      return (
        <div
          ref={setNodeRef}
          style={style}
          {...attributes}
          className="w-full p-5 rounded-md my-4 bg-white border"
        >
          <div className="flex gap-3 my-3 semibold">
            <Equal {...listeners} className="cursor-grab" />{" "}
            <Controller
              control={control}
              name={`items.${id}.title`}
              render={({ field }) => (
                <div className="w-full">
                  <Input
                    {...field}
                    className="border-0 shadow-none w-full border-b outline-none focus-visible:ring-0 focus-visible:ring-transparent"
                    placeholder="Enter Title"
                  />
                </div>
              )}
            />
            <XIcon
              className="h-5 w-5 cursor-pointer"
              onClick={() => {
                remove(id);
              }}
            />
          </div>

          {!isDragActive &&
            field?.children?.map((_, index) => (
              <div key={index} className="mb-[40px]">
                <div className="w-full flex justify-end">
                  {" "}
                  {index !== 0 && (
                    <X
                      className="cursor-pointer"
                      onClick={() => {
                        const allItems = getValues("items");
                        const updatedChildren = (
                          allItems[id]?.children ?? []
                        ).filter((_: any, childIndex: number) => childIndex !== index);
                        allItems[id].children = updatedChildren;
                        setValue("items", allItems);
                      }}
                    />
                  )}
                </div>
                <Controller
                  control={control}
                  name={`items.${id}.children.${index}.question`}
                  render={({ field }) => (
                    <div>
                      <span className="block my-2 text-[#212121] font-semibold">
                        Question
                      </span>
                      <Input
                        {...field}
                        className="Enter Question"
                        placeholder="Enter Question for this index"
                      />
                    </div>
                  )}
                />

                <Controller
                  control={control}
                  name={`items.${id}.children.${index}.answer`}
                  render={({ field }) => (
                    <div>
                      <span className="block my-2 text-[#212121] font-semibold">
                        Answer
                      </span>
                      <div className="">
                        {" "}
                        <TextEditor
                          {...field}
                          initialValue={field.value}
                          onChange={field.onChange}
                        />
                      </div>
                    </div>
                  )}
                />
              </div>
            ))}
          {!isDragActive && (
            <button
              type="button"
              className="flex items-center cursor-pointer justify-center gap-2 text-[#1DA077] font-semibold w-full"
              onClick={() => {
                console.log("MERO ID", id);
                addChildToDescription(id);
              }}
            >
              <PlusCircleIcon size={14} />
              Add More
            </button>
          )}
        </div>
      );

    case "description":
      return (
        <div
          ref={setNodeRef}
          style={style}
          {...attributes}
          className="w-full p-5 rounded-md  my-4 border bg-white"
        >
          <div className="flex my-3 gap-3 w-full font-semibold">
            <Equal {...listeners} className="cursor-grab" />{" "}
            <Controller
              control={control}
              name={`items.${id}.title`}
              render={({ field }) => (
                <div className="w-full">
                  <Input
                    {...field}
                    className="border-0 shadow-none w-full border-b outline-none focus-visible:ring-0 focus-visible:ring-transparent"
                    placeholder="Enter Title"
                  />
                </div>
              )}
            />{" "}
            <XIcon
              className="h-5 w-5 cursor-pointer"
              onClick={() => {
                remove(id);
              }}
            />
          </div>

          {!isDragActive && (
            <Controller
              control={control}
              name={`items.${id}.description`}
              render={({ field }) => (
                <div>
                  <span className="block my-2 semibold">Answer</span>
                  <div className="">
                    {" "}
                    <TextEditor
                      {...field}
                      initialValue={field.value}
                      onChange={field.onChange}
                    />
                  </div>
                </div>
              )}
            />
          )}
        </div>
      );

    default:
      return (
        <div
          ref={setNodeRef}
          style={style}
          {...attributes}
          {...listeners}
          className="w-full"
        >
          Default
        </div>
      );
  }
};

export default DragChild;
